<template>
    <div class="c-text-slider">
        <div class="c-text-slider__inner flex">
            <div class="c-text-slider__item" :style="animation">{{ text }}</div>
            <div class="c-text-slider__item" :style="animation">{{ text }}</div>
            <div class="c-text-slider__item" :style="animation">{{ text }}</div>
            <div class="c-text-slider__item" :style="animation">{{ text }}</div>
            <div class="c-text-slider__item" :style="animation">{{ text }}</div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'AnimatedText', 

        props: [
            'speed',
            'text'
        ],

        computed: {
            animation() {
                return `animation-duration: ${this.speed};`
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/imports";

    @keyframes scroll_horizontal_text {
        from { transform: translateX(0); }
        to { transform: translateX(-100%); }
    }

    .c-text-slider {
        position:relative;
        width:100%;
        overflow:hidden;  
        z-index: 1; 
        pointer-events: none;
        
        &__inner{
            padding:30px 0;
        }
        &__item {
            animation: scroll_horizontal_text 15s infinite linear forwards; 
            color: transparent; 
            font-family: $roboto; 
            font-weight:900;
            font-size: 3.5rem; 
            line-height:2.75rem;
            margin-right:$gutter*3;  
            -webkit-text-stroke: 1px $white; 
            white-space: nowrap;
        }
    }

    @media (prefers-reduced-motion: reduce) {
        .c-text-slider__item {animation: none;}
    }

    @media all and (min-width:$small-breakpoint){
        .c-text-slider{
            position: fixed; 
            width:60%;
            margin-left:0;
            top: calc((100vw * 0.6 * 0.33333 * 0.5625 * 4) + 60px); 
            left: 40%; 
            @include transform(translateY(-100%));
            &__inner{
                 padding:60px 0;
            }
            &__item{
                font-size:17.5rem;
                line-height:12.5rem;
                margin-right:$gutter*18;  
                 -webkit-text-stroke: 2px $white; 
            }
        }
    }

</style>